

function SplitSection() {
    return (
        <section className="w-full bg-white py-16">
            <div className="container mx-auto flex flex-col md:flex-row items-center px-6 md:px-12 lg:px-20">
                
                {/* Left side: Centered Text */}
                <div className="md:w-1/2 w-full mb-12 md:mb-0 flex items-center justify-center">
                    <div className="text-center">
                        <h2 className="text-4xl font-bold text-blue-900 mb-6">
                            Home-Cooked, Nutritious Meals
                        </h2>
                        <p className="text-lg text-blue-900 mb-4 max-w-md mx-auto">
                            At The One Childcare, food is an important part of our day. All meals and snacks are freshly prepared in our home kitchen using quality, whole ingredients. We focus on offering a balanced and varied diet that supports healthy growth and development.
                        </p>
                        <p className="text-lg text-blue-900 mb-6 max-w-md mx-auto">
                            From warm porridge in the morning to hearty vegetable stews at lunch, everything is made with little tummies in mind. We avoid processed foods and sugary snacks, opting instead for home-baked alternatives and naturally sweet fruits.
                        </p>
                    </div>
                </div>

                {/* Right side: Image */}
                <div className="md:w-1/2 w-full">
                    <img 
                        src="/food_one.jpg" 
                        alt="Happy children playing" 
                        className="rounded-lg shadow-lg w-full object-cover"
                    />
                </div>
            </div>
        </section>
    );
}

export default SplitSection;
